import { useCallback, useState } from "react";
import { toast } from "react-hot-toast";
import { useDeleteAssetCallback } from "./use-delete-asset-callback";

import type { UUID } from "../../../utils/uuid";

/** Archives a Design, as the Content Library does, and says how it went. Resolves to whether it was done. */
export function useArchiveDesign(id: UUID): {
  archive: () => Promise<boolean>;
  archiving: boolean;
} {
  const [archiving, setArchiving] = useState(false);
  const archiveAsset = useDeleteAssetCallback();

  const archive = useCallback(async (): Promise<boolean> => {
    setArchiving(true);
    try {
      const response = await archiveAsset(id);
      if (!response || response.error) {
        toast.error(`Something went wrong: ${response?.error.message}`);
        return false;
      }
      toast.success("Design successfully archived");
      return true;
    } finally {
      setArchiving(false);
    }
    // oxlint-disable-next-line react/memo-dependencies -- both are used; the rule misses uses inside try
  }, [id, archiveAsset]);

  return { archive, archiving };
}
